import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { SaleOfferBearingVisibility } from '../sale-offer-bearing-visibility';

export class SaleOfferBearingVisibilityBuilder {
  static fromJson(json): SaleOfferBearingVisibility {
    return (json) ? new SaleOfferBearingVisibility(
      json.saleOfferBearingHash,
      json.saleOfferLineHash
    ) : null;
  }

  static fromJsonList(list): SaleOfferBearingVisibility[] {
    return (isArray(list)) ? mapCollection(SaleOfferBearingVisibilityBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-bearing-visibility-builder.ts